export enum IconTextActionBehavior {
    Route = 'route',
    Emit = 'emit'
}
